//############################################################################################
//# axboot.validator
//############################################################################################

String.prototype.format = function() {
    var str = this;
    for (var i = 0; i < arguments.length; i++) {
        var reg = new RegExp('\\{' + i + '\\}', 'gm');
        str = str.replace(reg, arguments[i]);
    }

    return str;
}

String.prototype.trim = function() {
    return this.replace(/(^\s*)|(\s*$)/gi, '');
}

String.prototype.startsWith = function(str) {
    if (this.length < str.length) {
        return false;
    }

    return this.indexOf(str) == 0;
}

String.prototype.endsWith = function(str) {
    if (this.length < str.length) {
        return false;
    }

    return this.lastIndexOf(str) + str.length == this.length;
}

axboot.validator = function () {
    var __messageMap = {
        required     : '{0} 는(은) 필수 입력항목입니다.',
        length       : '{0} 는(은) {1}자로 입력해야 합니다.',
        maxLength    : '{0} 는(은) 최소 {1}자 이하로 입력해야합니다.',
        minLength    : '{0} 는(은) 최소 {1}자 이상으로 입력해야합니다.',
        max          : '{0} 는(은) 최대 {1}까지만 입력가능합니다.',
        min          : '{0} 는(은) 최소 {1} 이상 입력해야합니다.',
        number       : '{0} 는(은) 숫자만 입력가능합니다.',
        alphaNumeric : '{0} 는(은) 알파벳과 숫자만 입력가능합니다.',
        email        : '{0} 주소 형식이 잘못되었습니다.'
    }

    var __validateFunctionMap = {
        required : function (value, ruleMap) {
            var message = '';

            if (value === undefined) {
                value = '';
            } else if (typeof value === 'string') {
                value = value.replace(/^\s+|\s+$/g, '');
            }

            if (ax5.util.isNothing(value)) {
                message = __messageMap.required.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        length : function (value, ruleMap) {
            var message = '';
            var length = 0;

            if (!ax5.util.isNothing(value) && String(value).length != ruleMap['value']) {
                message = __messageMap.length.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        maxLength : function (value, ruleMap) {
        	
            var message = '';
            
            if (!ax5.util.isNothing(value) && String(value).length > ruleMap['value']) {
                message = __messageMap.maxLength.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        minLength : function (value, ruleMap) {
            var message = '';

            if (!ax5.util.isNothing(value) && String(value).length < ruleMap['value']) {
                message = __messageMap.minLength.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        max : function (value, ruleMap) {
            var message = '';

            if (parseFloat(value) > ruleMap['value']) {
                message = __messageMap.max.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        min : function (value, ruleMap) {
            var message = '';

            if (parseInt(value) < ruleMap['value']) {
                message = __messageMap.min.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        number : function (value, ruleMap) {
            var message = '';

            var pattern = /^\d+$/;

            if (!ax5.util.isNothing(value) && !pattern.test(value)) {
                message = __messageMap.number.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        alphaNumeric : function (value, ruleMap) {
            var message = '';

            var pattern = /^[0-9a-zA-Z]+$/;

            if (!ax5.util.isNothing(value) && !value.match(pattern)) {
                message = __messageMap.alphaNumeric.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        email : function (value, ruleMap) {
            var message = '';

            var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!ax5.util.isNothing(value) && !pattern.test(value)) {
                message = __messageMap.email.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        userFunc : function (value, ruleMap, data) {
            var message = '';

            if (ax5.util.isFunction(ruleMap['value'])) {
                return ruleMap['value'].call(this, value, ruleMap, data);
            } else {
                return __ruleMessage('');
            }
        }
    }

    var __ruleMessage = function (message) {
        /*
        var objResult = {
            result  : result
           ,message : message
       };
       */

       return message;
    }

    var __makeCompareValue = function (data, columns) {
        var delimiter = '__';
        var tempValue = '';
        var hasValue = false;

        if (!ax5.util.isNothing(columns)) {
            for (var k = 0; k < columns.length; k++) {
                tempValue += columns[k] + ':';

                if (!ax5.util.isNothing(data[columns[k]])) {
                    tempValue += data[columns[k]];
                    hasValue = true;
                }

                if (k < (columns.length - 1)) {
                    tempValue += delimiter;
                }
            }
        }

        return {
            'hasValue' : hasValue,
            'value'    : tempValue
        }
    }

    var __validateMessage = function (validationMappings, data) {
        var functionMap = {};
        var messageArray = new Array();
        var result;

        for (var validKey in validationMappings) {
            functionMap = validationMappings[validKey];

            // 대상 입력항목이 있을 경우
            //if (data.hasOwnProperty(validKey)) {
            for (var functionKey in functionMap) {
                result = __validateFunctionMap[functionKey].call(this, data[validKey], functionMap[functionKey], data);

                if (!ax5.util.isNothing(result)) {
                    messageArray.push(result);
                }
            }
            //}
        }

        return messageArray;
    }

    var validate = function (obj, validationRule) {
        var result = true;

        var gridList = obj.getData();
        var gridData = {};
        var columns = obj.target.columns;

        var messageArray = new Array();
        var resultArray = new Array();
        var messageLimitCount = 10;

        var objectType = axboot.util.getObjectType(obj);

        // GRID 유효성 검증
        if (objectType == 'GRID') {
            // 중복 데이터 처리
            if (!ax5.util.isNothing(validationRule['duplicate'])) {
                var saveValues = [];
                var duplicateColumns = validationRule['duplicate']['columns'];

                var duplicateIndex = -1;
                var hasDuplicate = false;
                var compareValue;

                // 입력된 데이터에 대한 비교값 생성
                for (var i = 0; i < gridList.length; i++) {
                    //if (axboot.util.getRowState(gridList[i]) == 'I') {
                    if (axboot.util.isSaveRow(gridList[i])) {
                        compareValue = __makeCompareValue(gridList[i], duplicateColumns);

                        if (compareValue['hasValue']) {
                            saveValues.push({ 'rowIndex' : i, 'value' : compareValue['value'] });
                        }
                    }
                }

                for (var i = 0; i < saveValues.length; i++) {
                    for (var k = 0; k < gridList.length; k++) {
                        if (k != saveValues[i]['rowIndex']) {
                            compareValue = __makeCompareValue(gridList[k], duplicateColumns);

                            if (saveValues[i]['value'] == compareValue['value']) {
                                duplicateIndex = saveValues[i]['rowIndex'];
                                hasDuplicate = true;
                                break;
                            }
                        }
                    }
                }

                if (hasDuplicate) {
                    resultArray.push({ 'rowIndex' : duplicateIndex, 'message' : '중복된 데이터가 존재합니다.', 'rowState' : axboot.util.getRowState(gridList[duplicateIndex]) });
                }
            }

            // 데이터 유효성 검증
            if (!ax5.util.isNothing(validationRule['rules'])) {
                for (var i = 0; i < gridList.length; i++) {
                    gridData = gridList[i];

                    if (axboot.util.isSaveRow(gridData)) {
                        messageArray = __validateMessage(validationRule['rules'], gridData);

                        for (var k = 0; k < messageArray.length; k++) {
                            resultArray.push({ 'rowIndex' : i, 'message' : messageArray[k], 'rowState' : axboot.util.getRowState(gridData) });
                        }
                    }
                }
            }
        }
        // 폼 유효성 검증
        else if (objectType == 'FORM') {
            if (!ax5.util.isNothing(validationRule['rules'])) {
                messageArray = __validateMessage(validationRule['rules'], obj.getData());

                for (var k = 0; k < messageArray.length; k++) {
                    resultArray.push({ 'rowIndex' : -1, 'message' : messageArray[k], 'rowState' : '' });
                }
            }
        }

        // 메시지 출력 처리
        if (resultArray.length > 0) {
            var errorMessage = '';

            for (var i = 0; i < resultArray.length; i++) {
                // 그리드일 경우 오류 발생 행 정보 추가
                if (objectType == 'GRID') {
                    errorMessage += '[' + (resultArray[i]['rowIndex'] + 1) + '행] '
                }

                errorMessage += resultArray[i]['message'] + '\n';

                if (i >= (messageLimitCount - 1) && (resultArray.length - messageLimitCount) > 0) {
                    errorMessage += '외 <b><font color="red">' + (resultArray.length - messageLimitCount) + '개</font></b> 의 입력오류 입니다.';
                    break;
                }
            }

            result = false;
        }

        var alert = function () {
            if (!result) {
                axDialog.alert({
                    theme : 'danger',
                    title : '입력오류 !',
                    msg   : errorMessage,
                    width : 500
                }, function () {
                    var objectType = axboot.util.getObjectType(obj);

                    if (objectType == 'GRID') {
                        var rowIndex = resultArray[0]['rowIndex'];
                        var rowItem = obj.target.getList()[rowIndex];

                        // 20180625 (이상훈) : tree 를 사용중이 아닐 경우에만 행전체 선택을 실행합니다. tree 일 경우 selectedClear 에서 오류 발생
                        if (obj.target.config.tree.use) {
                            obj.target.select(rowIndex);
                        } else {
                            obj.target.select(rowIndex, { selectedClear: true });
                        }

                        axboot.util.bindingTarget(obj.target.$target, rowItem);
                    }
                });
            }

            return result;
        }

        return {
            result   : result,
            messages : resultArray,
            alert    : alert
        }
    }

    return {
        //'duplicate' : duplicate,
        'validate'  : validate
    }
}();
